import { map, get, keyBy, find, filter, startsWith, toLower } from "lodash"
import { createSelector } from "reselect"
import moment from "moment"
import { matchATForecastByName } from "modules/portfolio-root/helpers"
import { getModels as getRawModels } from "resources/models"
import { getUploadingItems, getPermissions, getFavoritesAsObject } from "./items"

const EMPTY_ARRAY = []
export const getRawPortfolios = state => get(state, "global.data.accountPortfolios.data.portfolios", EMPTY_ARRAY)
const getForecasts = state => get(state, "global.data.forecasts.data.forecasts")

// This selector is used to prevent editing the name of a portfolio linked to an Alpha Theory forecast
// TODO: Replace this with relatedResource logic when implemented
export const getATForecasts = createSelector(
  [getForecasts],
  (forecasts) => filter(forecasts, ({ name }) => startsWith(toLower(name), "at pwr")),
)

export const getModels = createSelector(
  [getRawModels],
  (models) => keyBy(models, "id"),
)

export const getPortfolios = createSelector(
  [getRawPortfolios, getModels],
  (portfolios, models) =>
    map(portfolios, portfolio => {
      const info = []

      if (portfolio.defaultModelId) {
        info.push({ label: "Model", value: get(models, [portfolio.defaultModelId, "name"], portfolio.defaultModelId) })
      }

      if (portfolio.availableFrom) {
        info.push({ label: "Available from", value: moment(portfolio.availableFrom).format("ll") })
      }

      if (!portfolio.rolloverPositionSetToCurrentDate) {
        info.push({ label: "This portfolio does not rollover positions." })
      } else {
        info.push({ label: "This portfolio is set to rollover positions." })
      }

      return {
        ...portfolio,
        label: portfolio.name,
        resourceType: "portfolio",
        noData: !portfolio.availableFrom,
        info,
        modelId: portfolio.defaultModelId,
      }
    }),
)

export const getPortfoliosWithMeta = createSelector(
  [getPortfolios, getATForecasts, getPermissions, getFavoritesAsObject, getUploadingItems],
  (portfolios, atForecasts, permissions, favorites, uploadingItems) => map(portfolios, portfolio => ({
    ...portfolio,
    ...find(permissions, ({ id }) => id === portfolio.id),
    // components/edit-portfolio uses live instead of rolloverPositionSetToCurrentDate
    // we can't modify while we run resources & resources2
    live: portfolio.rolloverPositionSetToCurrentDate,
    shortType: "p",
    type: "Portfolio",
    isLinkedToAlphaTheory: matchATForecastByName(portfolio.name, atForecasts),
    isFavorite: get(favorites, portfolio.id, false),
    refresh: get(uploadingItems, portfolio.id, false),
  })),
)
